import { Box } from '@material-ui/core'
import { FunctionComponent } from 'react'
import styled from 'styled-components/macro'
//@ts-ignore
import { useThemeSwitch } from 'hooks/theme'
import { useHistory } from 'react-router'

const StyledImage = styled.img`
  height: auto;
  width: 100%;
`

export type LogoSize = 'xxx-small' | 'xx-small' | 'x-small' | 'small' | 'medium' | 'large' | 'x-large'
interface LogoProps {
  size?: LogoSize
  bright?: boolean
  noBorder?: boolean
  pathname?: string
  isSummit?: boolean
  notClickable?: boolean
  borderColor?: string
  isIconLogo?: boolean
}

export const Logo: FunctionComponent<LogoProps> = ({
  size,
  bright,
  noBorder,
  pathname,
  isSummit,
  notClickable,
  borderColor,
  isIconLogo
}) => {
  const { mode } = useThemeSwitch()
  const history = useHistory()

  const redirectToHome = e => {
    history.push('/feed')
  }

  const getSizing = () => {
    switch (size) {
      case 'xxx-small':
        return { height: '29px', width: '29px' }
      case 'xx-small':
        return { height: '40px', width: '40px' }
      case 'x-small':
        return { height: '50px', width: '100px' }
      case 'small':
        return { height: '48px', width: '116px' }
      case 'medium':
        return { height: '200px', width: '400px' }
      case 'large':
        return { height: '250px', width: '500px' }
      case 'x-large':
        return { height: '500px', width: '1000px' }
      default:
        return { height: '70px', width: '150px' }
    }
  }

  const chooseRedirection = () => {
    pathname && pathname?.includes('feed')
      ? () => {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        }
      : redirectToHome
  }

  return (
    <Box
      id="top"
      onClick={notClickable ? null : chooseRedirection}
      style={{
        cursor: 'pointer'
      }}
      display="flex"
      alignItems="center"
      {...getSizing()}
    >
      {!isIconLogo && (
        <StyledImage
          onClick={notClickable ? null : redirectToHome}
          src={
            (mode === 'dark' && bright) || isSummit
              ? `/assets/logos/bptn/obsidi_logo_black.png`
              : `/assets/logos/bptn/obsidi_logo_white.png`
          }
        />
      )}
      {isIconLogo && (
        <StyledImage
          onClick={notClickable ? null : redirectToHome}
          src={
            (mode === 'dark' && bright) || isSummit
              ? `/assets/logos/bptn/obsidi_logo_icon_black.png`
              : `/assets/logos/bptn/obsidi_logo_icon_white.png`
          }
        />
      )}
    </Box>
  )
}
